(() => {
  if (window.SSWishlistHeartReady) return;
  window.SSWishlistHeartReady = true;

  const STORAGE_KEY = 'ss_saved_products_v1';

  const CARD_SELECTOR = [
    '.product-card-wrapper',
    '.ss-product-card',
    '[data-product-card]'
  ].join(',');

  /* =========================================================
     STORAGE
  ========================================================= */

  function readWishlist() {
    try {
      const stored = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(stored)
        ? stored
        : [];
    } catch (error) {
      console.warn(
        'Wishlist storage could not be read.',
        error
      );

      return [];
    }
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(items)
      );
    } catch (error) {
      console.warn(
        'Wishlist could not be saved.',
        error
      );
    }

    document.dispatchEvent(
      new CustomEvent(
        'ss:wishlist:update',
        {
          detail: {
            count: items.length,
            items
          }
        }
      )
    );

    syncAllControls();
    renderWishlistPage();
  }

  function isSaved(handle) {
    if (!handle) return false;

    return readWishlist().some(
      (item) =>
        item.handle === handle
    );
  }

  /* =========================================================
     PRODUCT DATA
  ========================================================= */

  function getProductLink(card) {
    if (!card) return null;

    const links = Array.from(
      card.querySelectorAll(
        'a[href*="/products/"]'
      )
    );

    return (
      links.find((link) => {
        try {
          const url =
            new URL(
              link.href,
              window.location.href
            );

          return /\/products\/[^/?#]+/.test(
            url.pathname
          );
        } catch (error) {
          return false;
        }
      }) || null
    );
  }

  function normaliseProductUrl(
    url,
    handle
  ) {
    if (url) {
      try {
        return new URL(
          url,
          window.location.origin
        ).pathname;
      } catch (error) {}
    }

    return handle
      ? `/products/${handle}`
      : '';
  }

  function productDataFromCard(card) {
    const link =
      getProductLink(card);

    if (!link) return null;

    const url =
      new URL(
        link.href,
        window.location.href
      );

    const match =
      url.pathname.match(
        /\/products\/([^/?#]+)/
      );

    const handle =
      match?.[1] || '';

    if (!handle) return null;

    const image =
      card.querySelector(
        [
          '.card__media img',
          '.ss-product-card__image',
          '.ss-product-card__media img',
          'img'
        ].join(',')
      );

    const titleElement =
      card.querySelector(
        [
          '.card__heading',
          '.ss-product-card__title',
          '[class*="product-title"]'
        ].join(',')
      );

    return {
      handle,

      title:
        titleElement
          ?.textContent
          ?.trim() ||
        link.getAttribute(
          'aria-label'
        ) ||
        link.textContent.trim() ||
        handle,

      url:
        normaliseProductUrl(
          url.pathname,
          handle
        ),

      image:
        image?.currentSrc ||
        image?.src ||
        ''
    };
  }

  function productDataFromControl(
    control
  ) {
    if (!control) return null;

    const handle =
      control.dataset
        .productHandle || '';

    if (!handle) return null;

    return {
      handle,

      title:
        control.dataset
          .productTitle ||
        handle,

      url:
        normaliseProductUrl(
          control.dataset
            .productUrl,
          handle
        ),

      image:
        control.dataset
          .productImage || ''
    };
  }

  /* =========================================================
     HEART UI
  ========================================================= */

  function updateControl(
    control,
    saved
  ) {
    if (!control) return;

    control.classList.toggle(
      'is-saved',
      saved
    );

    control.setAttribute(
      'aria-pressed',
      String(saved)
    );

    control.setAttribute(
      'aria-label',
      saved
        ? 'Remove from wishlist'
        : 'Add to wishlist'
    );

    const textHeart =
      control.querySelector(
        '.ss-wishlist-heart'
      );

    if (textHeart) {
      textHeart.innerHTML =
        saved
          ? '&#9829;'
          : '&#9825;';
    }

    const svg =
      control.querySelector(
        'svg'
      );

    if (svg) {
      svg.style.fill =
        saved
          ? 'currentColor'
          : 'none';
    }
  }

  function syncAllControls() {
    document
      .querySelectorAll(
        '[data-product-handle]'
      )
      .forEach((control) => {
        const handle =
          control.dataset
            .productHandle;

        if (!handle) return;

        updateControl(
          control,
          isSaved(handle)
        );
      });
  }

  /* =========================================================
     TOAST
  ========================================================= */

  function showToast(message) {
    let toast =
      document.querySelector(
        '.ss-wishlist-toast'
      );

    if (!toast) {
      toast =
        document.createElement(
          'div'
        );

      toast.className =
        'ss-wishlist-toast';

      toast.setAttribute(
        'role',
        'status'
      );

      toast.setAttribute(
        'aria-live',
        'polite'
      );

      document.body.appendChild(
        toast
      );
    }

    toast.textContent =
      message;

    toast.classList.remove(
      'is-visible'
    );

    void toast.offsetWidth;

    toast.classList.add(
      'is-visible'
    );

    clearTimeout(
      toast.hideTimer
    );

    toast.hideTimer =
      setTimeout(() => {
        toast.classList.remove(
          'is-visible'
        );
      }, 1800);
  }

  /* =========================================================
     HEART BURST
  ========================================================= */

  function burst(button) {
    if (
      !button ||
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches ||
      typeof button.animate !==
        'function'
    ) {
      return;
    }

    const rect =
      button.getBoundingClientRect();

    const x =
      rect.left +
      rect.width / 2;

    const y =
      rect.top +
      rect.height / 2;

    const colours = [
      '#e92836',
      '#ff7180',
      '#f4b5bd',
      '#ffffff'
    ];

    for (
      let index = 0;
      index < 9;
      index += 1
    ) {
      const particle =
        document.createElement(
          'i'
        );

      const angle =
        (Math.PI * 2 * index) /
        9;

      const distance =
        22 +
        Math.random() * 25;

      particle.className =
        'ss-wishlist-particle';

      particle.style.left =
        `${x}px`;

      particle.style.top =
        `${y}px`;

      particle.style.background =
        colours[
          index %
          colours.length
        ];

      document.body.appendChild(
        particle
      );

      particle
        .animate(
          [
            {
              opacity: 1,
              transform:
                'translate(-50%, -50%) scale(1)'
            },
            {
              opacity: 0,
              transform:
                `translate(
                  calc(-50% + ${
                    Math.cos(
                      angle
                    ) *
                    distance
                  }px),
                  calc(-50% + ${
                    Math.sin(
                      angle
                    ) *
                    distance
                  }px)
                ) scale(0)`
            }
          ],
          {
            duration: 600,
            easing:
              'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'forwards'
          }
        )
        .finished
        .catch(() => {})
        .finally(() => {
          particle.remove();
        });
    }
  }

  /* =========================================================
     SAVE / REMOVE PRODUCT
  ========================================================= */

  function toggleProduct(
    control,
    product
  ) {
    if (!product?.handle) {
      return;
    }

    const wishlist =
      readWishlist();

    const existingIndex =
      wishlist.findIndex(
        (item) =>
          item.handle ===
          product.handle
      );

    if (existingIndex >= 0) {
      wishlist.splice(
        existingIndex,
        1
      );

      updateControl(
        control,
        false
      );

      showToast(
        'Removed from wishlist'
      );
    } else {
      wishlist.push({
        handle:
          product.handle,

        title:
          product.title ||
          product.handle,

        url:
          normaliseProductUrl(
            product.url,
            product.handle
          ),

        image:
          product.image || ''
      });

      updateControl(
        control,
        true
      );

      burst(control);

      showToast(
        'Saved to wishlist'
      );
    }

    writeWishlist(
      wishlist
    );
  }

  /* =========================================================
     BIND HEART
  ========================================================= */

  function bindControl(
    control,
    product
  ) {
    if (
      !control ||
      !product?.handle
    ) {
      return;
    }

    control.dataset
      .productHandle =
      product.handle;

    control.dataset
      .productTitle =
      product.title || '';

    control.dataset
      .productUrl =
      normaliseProductUrl(
        product.url,
        product.handle
      );

    control.dataset
      .productImage =
      product.image || '';

    updateControl(
      control,
      isSaved(
        product.handle
      )
    );

    if (
      control.dataset
        .ssWishlistReady ===
      'true'
    ) {
      return;
    }

    control.dataset
      .ssWishlistReady =
      'true';

    control.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        toggleProduct(
          control,
          productDataFromControl(
            control
          ) || product
        );
      }
    );
  }

  /* =========================================================
     PRODUCT CARD
  ========================================================= */

  function setupCard(card) {
    if (!card) return;

    if (
      card.closest(
        [
          '#SSProductQuickView',
          'cart-drawer',
          'cart-notification'
        ].join(',')
      )
    ) {
      return;
    }

    const product =
      productDataFromCard(
        card
      );

    if (!product) return;

    card.classList.add(
      'ss-wishlist-card'
    );

    let control =
      card.querySelector(
        [
          '.ss-product-card__wishlist',
          '[data-ss-card-wishlist]'
        ].join(',')
      );

    if (!control) {
      control =
        document.createElement(
          'button'
        );

      control.type =
        'button';

      control.className =
        'ss-wishlist-button';

      control.innerHTML =
        '<span class="ss-wishlist-heart" aria-hidden="true">&#9825;</span>';

      card.appendChild(
        control
      );
    }

    control.classList.add(
      'ss-wishlist-existing-control'
    );

    bindControl(
      control,
      product
    );
  }

  /* =========================================================
     PRODUCT PAGE HEART
  ========================================================= */

  function setupProductPageControls(
    root = document
  ) {
    let controls = [];

    if (
      root.matches &&
      root.matches(
        '[data-ss-product-wishlist]'
      )
    ) {
      controls = [
        root
      ];
    } else if (
      root.querySelectorAll
    ) {
      controls =
        Array.from(
          root.querySelectorAll(
            '[data-ss-product-wishlist]'
          )
        );
    }

    controls.forEach(
      (control) => {
        const product =
          productDataFromControl(
            control
          );

        bindControl(
          control,
          product
        );
      }
    );
  }

  /* =========================================================
     SCAN PAGE
  ========================================================= */

  function scan(
    root = document
  ) {
    let cards = [];

    if (
      root.matches &&
      root.matches(
        CARD_SELECTOR
      )
    ) {
      cards = [
        root
      ];
    } else if (
      root.querySelectorAll
    ) {
      cards =
        Array.from(
          root.querySelectorAll(
            CARD_SELECTOR
          )
        );
    }

    cards.forEach(
      setupCard
    );

    setupProductPageControls(
      root
    );
  }

  /* =========================================================
     WISHLIST PAGE
  ========================================================= */

  let wishlistRenderToken =
    0;

  function safeText(value) {
    return String(
      value || ''
    )
      .replace(
        /&/g,
        '&amp;'
      )
      .replace(
        /</g,
        '&lt;'
      )
      .replace(
        />/g,
        '&gt;'
      )
      .replace(
        /"/g,
        '&quot;'
      )
      .replace(
        /'/g,
        '&#039;'
      );
  }

  function formatMoney(
    cents
  ) {
    try {
      return new Intl.NumberFormat(
        'en-IN',
        {
          style: 'currency',
          currency: 'INR',
          maximumFractionDigits: 0
        }
      ).format(
        (Number(cents) || 0) /
          100
      );
    } catch (error) {
      return `₹${Math.round(
        (Number(cents) || 0) /
          100
      )}`;
    }
  }

  async function fetchProduct(
    handle
  ) {
    try {
      const response =
        await fetch(
          `/products/${encodeURIComponent(
            handle
          )}.js`,
          {
            credentials:
              'same-origin',

            headers: {
              Accept:
                'application/json'
            }
          }
        );

      if (!response.ok) {
        throw new Error(
          `Product request failed: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.warn(
        `Wishlist product could not load: ${handle}`,
        error
      );

      return null;
    }
  }

  function removeWishlistItem(
    handle
  ) {
    if (!handle) return;

    const next =
      readWishlist().filter(
        (item) =>
          item.handle !==
          handle
      );

    writeWishlist(next);

    showToast(
      'Removed from wishlist'
    );
  }

  function createWishlistCard(
    product,
    fallback
  ) {
    const handle =
      product?.handle ||
      fallback.handle;

    const title =
      product?.title ||
      fallback.title ||
      handle;

    const url =
      product?.url ||
      fallback.url ||
      `/products/${handle}`;

    const image =
      product?.featured_image ||
      product?.images?.[0] ||
      fallback.image ||
      '';

    const price =
      product &&
      typeof product.price !==
        'undefined'
        ? formatMoney(
            product.price
          )
        : '';

    const item =
      document.createElement(
        'article'
      );

    item.className =
      'ss-wishlist-item';

    item.dataset.handle =
      handle;

    item.innerHTML = `
      <div class="ss-wishlist-item__media">

        <a
          href="${safeText(
            url
          )}"
          class="ss-wishlist-item__image-link"
        >
          ${
            image
              ? `<img
                  src="${safeText(
                    image
                  )}"
                  alt="${safeText(
                    title
                  )}"
                  loading="lazy"
                >`
              : ''
          }
        </a>

        <button
          type="button"
          class="ss-wishlist-item__remove"
          data-remove-wishlist
          aria-label="Remove ${safeText(
            title
          )} from wishlist"
        >
          ♥
        </button>

      </div>

      <div class="ss-wishlist-item__body">

        <h3 class="ss-wishlist-item__title">

          <a
            href="${safeText(
              url
            )}"
          >
            ${safeText(
              title
            )}
          </a>

        </h3>

        ${
          price
            ? `
              <div class="ss-wishlist-item__price">
                ${safeText(
                  price
                )}
              </div>
            `
            : ''
        }

        <a
          href="${safeText(
            url
          )}"
          class="ss-wishlist-item__view"
        >
          View Product
        </a>

      </div>
    `;

    item
      .querySelector(
        '[data-remove-wishlist]'
      )
      ?.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          removeWishlistItem(
            handle
          );
        }
      );

    return item;
  }

  async function renderWishlistPage() {
    const grid =
      document.querySelector(
        '[data-ss-wishlist-grid]'
      );

    if (!grid) return;

    const empty =
      document.querySelector(
        '[data-ss-wishlist-empty]'
      );

    const loading =
      document.querySelector(
        '[data-ss-wishlist-loading]'
      );

    const count =
      document.querySelector(
        '[data-ss-wishlist-count]'
      );

    const items =
      readWishlist();

    const currentToken =
      ++wishlistRenderToken;

    if (count) {
      count.textContent =
        items.length === 1
          ? '1 saved product'
          : `${items.length} saved products`;
    }

    grid.innerHTML = '';

    if (!items.length) {
      if (loading) {
        loading.hidden =
          true;
      }

      if (empty) {
        empty.hidden =
          false;
      }

      grid.hidden =
        true;

      return;
    }

    if (loading) {
      loading.hidden =
        false;
    }

    if (empty) {
      empty.hidden =
        true;
    }

    grid.hidden =
      true;

    const products =
      await Promise.all(
        items.map(
          (item) =>
            fetchProduct(
              item.handle
            )
        )
      );

    if (
      currentToken !==
      wishlistRenderToken
    ) {
      return;
    }

    items.forEach(
      (item, index) => {
        grid.appendChild(
          createWishlistCard(
            products[index],
            item
          )
        );
      }
    );

    if (loading) {
      loading.hidden =
        true;
    }

    if (empty) {
      empty.hidden =
        true;
    }

    grid.hidden =
      false;
  }

  /* =========================================================
     STYLES
  ========================================================= */

  const style =
    document.createElement(
      'style'
    );

  style.textContent = `
    .ss-wishlist-card {
      position: relative;
    }

    .ss-wishlist-button {
      position: absolute;
      z-index: 15;
      top: 12px;
      right: 12px;
      width: 42px;
      height: 42px;
      display: grid;
      place-items: center;
      padding: 0;
      border: 1px solid rgba(255,255,255,.72);
      border-radius: 50%;
      color: #171717;
      background: rgba(255,255,255,.82);
      box-shadow: 0 8px 24px rgba(0,0,0,.13);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      cursor: pointer;

      transition:
        transform 180ms cubic-bezier(.22,1,.36,1),
        color 180ms ease,
        background 180ms ease;
    }

    .ss-wishlist-button:hover {
      transform:
        translateY(-2px)
        scale(1.06);
    }

    .ss-wishlist-button:active {
      transform:
        scale(.88);
    }

    .ss-wishlist-button.is-saved,
    .ss-product-card__wishlist.is-saved,
    [data-ss-card-wishlist].is-saved,
    [data-ss-product-wishlist].is-saved {
      color:
        #e92836 !important;
    }

    .ss-product-card__wishlist.is-saved svg,
    [data-ss-card-wishlist].is-saved svg,
    [data-ss-product-wishlist].is-saved svg {
      fill:
        currentColor !important;
    }

    .ss-wishlist-heart {
      display: block;
      font-family:
        Arial,
        sans-serif;
      font-size: 27px;
      line-height: 1;
    }

    .ss-wishlist-particle {
      position: fixed;
      z-index: 2147483001;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      pointer-events: none;
    }

    .ss-wishlist-toast {
      position: fixed;
      z-index: 2147483002;
      left: 50%;
      bottom: 28px;

      max-width:
        calc(100vw - 32px);

      padding:
        12px 18px;

      border-radius:
        999px;

      color:
        #ffffff;

      background:
        rgba(23,23,23,.92);

      box-shadow:
        0 14px 42px
        rgba(0,0,0,.25);

      backdrop-filter:
        blur(12px);

      -webkit-backdrop-filter:
        blur(12px);

      opacity: 0;
      pointer-events: none;

      transform:
        translate(-50%,18px)
        scale(.94);

      transition:
        opacity 220ms ease,
        transform 320ms
        cubic-bezier(.22,1,.36,1);
    }

    .ss-wishlist-toast.is-visible {
      opacity: 1;

      transform:
        translate(-50%,0)
        scale(1);
    }

    .ss-wishlist-item {
      min-width: 0;
    }

    .ss-wishlist-item__media {
      position: relative;
      overflow: hidden;

      aspect-ratio:
        4 / 5;

      border-radius:
        14px;

      background:
        #ffffff;
    }

    .ss-wishlist-item__image-link {
      display: block;
      width: 100%;
      height: 100%;
    }

    .ss-wishlist-item__media img {
      width: 100%;
      height: 100%;
      display: block;

      object-fit:
        contain;

      transition:
        transform 380ms ease;
    }

    .ss-wishlist-item:hover
    .ss-wishlist-item__media img {
      transform:
        scale(1.035);
    }

    .ss-wishlist-item__remove {
      position: absolute;
      z-index: 4;

      top: 12px;
      right: 12px;

      width: 40px;
      height: 40px;

      display: grid;
      place-items: center;

      padding: 0;
      border: 0;

      border-radius:
        50%;

      color:
        #e92836;

      background:
        rgba(255,255,255,.92);

      box-shadow:
        0 6px 22px
        rgba(0,0,0,.11);

      cursor: pointer;

      font-size:
        23px;

      line-height:
        1;
    }

    .ss-wishlist-item__body {
      padding:
        15px 2px 0;
    }

    .ss-wishlist-item__title {
      margin: 0;

      font-size:
        16px;

      line-height:
        1.35;

      font-weight:
        700;
    }

    .ss-wishlist-item__title a {
      color:
        inherit;

      text-decoration:
        none;
    }

    .ss-wishlist-item__price {
      margin-top:
        8px;

      font-size:
        15px;

      font-weight:
        700;
    }

    .ss-wishlist-item__view {
      margin-top:
        14px;

      min-height:
        46px;

      width:
        100%;

      display:
        inline-flex;

      align-items:
        center;

      justify-content:
        center;

      border-radius:
        8px;

      color:
        #ffffff;

      background:
        #171717;

      text-decoration:
        none;

      font-size:
        13px;

      font-weight:
        800;
    }

    @media (
      max-width: 749px
    ) {
      .ss-wishlist-button {
        top: 8px;
        right: 8px;

        width:
          38px;

        height:
          38px;
      }

      .ss-wishlist-heart {
        font-size:
          24px;
      }

      .ss-wishlist-toast {
        bottom:
          88px;
      }
    }

    @media (
      prefers-reduced-motion: reduce
    ) {
      .ss-wishlist-button,
      .ss-wishlist-toast,
      .ss-wishlist-item__media img {
        animation:
          none !important;

        transition:
          none !important;
      }

      .ss-wishlist-particle {
        display:
          none !important;
      }
    }
  `;

  document.head.appendChild(
    style
  );

  /* =========================================================
     START
  ========================================================= */

  scan();

  renderWishlistPage();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      scan(
        event.target
      );

      renderWishlistPage();
    }
  );

  document.addEventListener(
    'ss:wishlist:update',
    () => {
      syncAllControls();
    }
  );

  window.addEventListener(
    'storage',
    (event) => {
      if (
        event.key ===
        STORAGE_KEY
      ) {
        syncAllControls();
        renderWishlistPage();
      }
    }
  );

  new MutationObserver(
    (records) => {
      records.forEach(
        (record) => {
          record.addedNodes.forEach(
            (node) => {
              if (
                node.nodeType === 1
              ) {
                scan(node);
              }
            }
          );
        }
      );
    }
  ).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  window.SSWishlist = {
    read:
      readWishlist,

    render:
      renderWishlistPage,

    remove:
      removeWishlistItem
  };
})();